/**
 * All the tabs/stages possible for ConfigMigration.
 */
export enum MigrationTab {
  MANAGEMENT = 'MANAGEMENT',
  EXPORT = 'EXPORT',
  IMPORT = 'IMPORT',
}

export const DEFAULT_TAB = MigrationTab.IMPORT;
